import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { postAnalyticsEventService } from "../../Services/analyticsEvents.service";

// /org-admin/evaluationpage/<id>, /hr/interview-report/<id>, ...
const REPORT_ROUTE = /^\/(?:org-admin|hr)\/(?:evaluationpage|interview-report)\/([^/?#]+)/;

/**
 * Reports two browser-side moments to analytics without touching the report
 * components themselves:
 *
 *   evaluation_report_viewed  an interview report page opened
 *   shortlist_viewed          a screened candidate's analysis report opened
 *                             (the server keeps only a user's first one)
 *
 * Renders nothing. Mounted once in each portal layout.
 */
const AnalyticsWatcher = () => {
  const { pathname } = useLocation();
  const isAnalysisOpen = useSelector((state) => state.candidateManagementSlice.isReportModalOpen);
  const analysisCandidate = useSelector((state) => state.candidateManagementSlice.currentCandidate);
  const lastReport = useRef(null);
  // The server keeps only the first one anyway; no need to ask again this session
  const shortlistSent = useRef(false);

  useEffect(() => {
    const interviewId = pathname.match(REPORT_ROUTE)?.[1];
    if (!interviewId || lastReport.current === interviewId) return;
    lastReport.current = interviewId;
    postAnalyticsEventService("evaluation_report_viewed", { interview_id: interviewId });
  }, [pathname]);

  useEffect(() => {
    if (!isAnalysisOpen || shortlistSent.current) return;
    shortlistSent.current = true;
    const roleId = analysisCandidate?.job_id || analysisCandidate?.jd_id;
    postAnalyticsEventService("shortlist_viewed", roleId ? { role_id: String(roleId) } : {});
  }, [isAnalysisOpen, analysisCandidate]);

  return null;
};

export default AnalyticsWatcher;
